
import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import DropFile from "../AppsMenu/Email/Compose/DropFile";
import { Badge } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { toast } from "react-toastify";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const SendEmail = forwardRef((props, ref) => {
  const { instance, accounts } = useMsal();
  const [popup, setPopup] = useState(false);
  
  const [formData, setFormData] = useState({
    body: `<p>Hi #title# #firstName# #lastName#</p>\n\n <br><br>
<p>Regards,<br> ${props?.user?.firstName} ${props?.user?.lastName}</p>`
  });

  const availablePlaceholders = [
    { placeholder: "#title#", description: "Candidate title (Mr., Mrs., etc.)" },
    { placeholder: "#firstName#", description: "Candidate first name" },
    { placeholder: "#lastName#", description: "Candidate last name" },
    { placeholder: "#email#", description: "Candidate email address" },
    { placeholder: "#personId#", description: "Candidate person ID" },
    { placeholder: "#companyName#", description: "Company name being contacted" },
    { placeholder: "#lastWorkedCompany#", description: "Last company candidate worked for" }
  ];

  useEffect(()=>{
    if(props.user) {
      
      setFormData({ ...formData,  body: `<p>Hi #title# #firstName# #lastName#</p>\n\n <br><br>
        <p>Regards, <br> ${props?.user?.firstName} ${props?.user?.lastName}</p>` });
    }
  },[props.user])

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  useEffect(()=>{
    setFormData({body: `<p>Hi #title# #firstName# #lastName#</p>\n\n <br><br>
      <p>Regards, <br>${props?.user?.firstName} ${props?.user?.lastName}</p>`})
  },[popup])

  useImperativeHandle(ref, () => ({
    showEmailModal() {
      setPopup(true);
    },
  }));

  const replacePlaceholders = (template, values) => {
    return template.replace(/#(\w+)#/g, (match, key) => values[key] || match);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (!form.checkValidity()) {
      form.reportValidity();
    }
    sendMail()
    setPopup(false);
  };

  const sendMail = async() => {
    if(props.isCompany) {
      for(const comdata of  props.data) {
        for(const data of  comdata?.compContacts) {
        const emailPayload = {
          message: {
            subject: formData?.subject,
            body: {
              contentType: "html",
              content: "<html><head>\r\n<meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\"></head><body>"+replacePlaceholders(formData?.body,data)+"</body></html>"
            },
            toRecipients: [
              {
                emailAddress: {
                  address: data?.email,
                },
              },
            ],
          },
          saveToSentItems: "true",
        };
        const accessToken = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const response = await fetch("https://graph.microsoft.com/v1.0/me/sendMail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken.accessToken}`,
          },
          body: JSON.stringify(emailPayload),
        });
      }
      }
    } else {
      for(const data of  props.data) {

        const emailPayload = {
          message: {
            subject: formData?.subject,
            body: {
              contentType: "html",
              content: "<html><head>\r\n<meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\"></head><body>"+replacePlaceholders(formData?.body,data)+"</body></html>"
            },
            toRecipients: [
              {
                emailAddress: {
                  address: data?.email,
                },
              },
            ],
          },
          saveToSentItems: "true",
        };
        const accessToken = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const response = await fetch("https://graph.microsoft.com/v1.0/me/sendMail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken.accessToken}`,
          },
          body: JSON.stringify(emailPayload),
        });
      }
    }
    

    toast.success("Email sent successfully!");

  }

  return (
    <>
      <Offcanvas
        show={popup}
        onHide={() => setPopup(false)}
        className="offcanvas-end customeoff"
        placement="end"
        style={{zIndex: 1111}}
      >
        <div className="offcanvas-header">
          <h5 className="modal-title" id="#gridSystemModal">
            {props.Title}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setPopup(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="container-fluid">
            <form onSubmit={handleSubmit}>
              <div className="row">
                
                    <div className="col-xl-12 mb-12">
                    <div className="compose-wrapper mt-3" id="compose-content">
											<div className="compose-content">
												<form >
													<div className="form-group mb-3">
                          <div className="bootstrap-badge" style={{border: '1px solid rgba(0, 0, 0, 0.1)', padding: '5px', borderRadius: '5px'}}>
                          &nbsp;&nbsp;&nbsp;&nbsp;To : &nbsp;
                            {props.data && Array.isArray(props.data) && props.data.length > 0 ? props.data.map(data => props.isCompany ? <>
                              {data.compContacts && data.compContacts.length > 0 ? data.compContacts.map(d=>
                                <Badge bg="info" className='me-2'>{d?.email}</Badge>
                              ) : null}
                            </> 
                            :
                              <Badge bg="info" className='me-2'>{data?.email}</Badge>
                            ) : null}
                             </div>
													</div>
													<div className="form-group mb-3">
													<input type="text" className="form-control bg-transparent" placeholder=" Subject:"
                           required
                           value={formData?.subject}
                           onChange={(e) =>
                             handleInputChange("subject", e.target.value)
                           }
                          />
													</div>
													<div className="form-group mb-3">
                          <Badge  bg="" className='badge-secondary light'><i className="fa fa-info me-2"></i>
                          { props?.hint ? props?.hint : "Please use #title#, #firstName# , #lastName# to dynamically map values"}</Badge>
                        
													{/* <textarea id="email-compose-editor" className="textarea_editor form-control bg-transparent" rows="5"
                            required
                            value={formData?.body}
                            onChange={(e) =>
                              handleInputChange("body", e.target.value)
                            }
														placeholder="Enter text ..."
													></textarea> */}
                          <hr />
                                    <CKEditor
                                    data={formData?.body}
                                        editor={ ClassicEditor }
                                   
                                        onReady={ editor => {
                                            
                                        } }
                                        onChange={ ( event, editor ) => {
                                            const data = editor.getData();
                                            handleInputChange("body", data)
                                            //console.log('data',data)
                                            
                                        } }
                                        onBlur={ ( event, editor ) => {
                                           
                                        } }
                                        onFocus={ ( event, editor ) => {
                                           
                                        } }
                                    />
                              
													</div>
													
													{/* Placeholder Reference */}
													<div className="mt-3 p-3 bg-light rounded">
														<h6>Available Placeholders:</h6>
														<div className="row">
															{availablePlaceholders.map((item, index) => (
																<div key={index} className="col-md-6 mb-2">
																	<code className="bg-white p-1 rounded border">{item.placeholder}</code>
																	<small className="d-block text-muted">{item.description}</small>
																</div>
															))}
														</div>
													</div>
												</form>
												{/* <h5 className="my-3"><i className="fa fa-paperclip me-2"></i> Attatchment</h5>
												<DropFile /> */}
                        
											</div>
											<div className="text-left mt-4 mb-5">
												<button
													className="btn btn-primary btn-sl-sm me-2"
													type="submit"
												>
													<span className="me-2">
													<i className="fa fa-paper-plane"></i>
													</span>
													Send
												</button>
												<button
													className="btn btn-danger light btn-sl-sm"
													type="button" onClick={()=>  setPopup(false)}
												>
													<span className="me-2">
													<i className="fa fa-times" aria-hidden="true"></i>
													</span>
													Discard
												</button>
											</div>
                      </div>
										</div>	
              </div>
            </form>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default SendEmail;
